import { ApolloError } from '@apollo/client';
import {
  getGraphQLErrorMachineCode,
  MembershipsConfigErrorCode,
} from 'src/graphql/error-codes/memberships-config-error-codes';

const PROJECT_ACTION_ERRORS = [
  {
    error: 'Address not found',
    message: 'Error: Site not found',
  },
  {
    error: 'Primary client not found',
    message: 'Error: Please set a primary client for the site',
  },
  {
    error: 'Product for trial not found',
    message: 'Error: Could not create or update Stripe subscription',
  },
  {
    error: 'Product for pre-sold membership not found',
    message: 'Error: Could not create or update Stripe subscription',
  },
  {
    error: 'Partner does not have a Stripe account',
    message: 'Error: No Stripe configuration found for the partner',
  },
  {
    error: 'Could not find the necessary data to create a new price point for partner',
    message: 'Error: Could not create or update Stripe subscription',
  },
  {
    error: 'No PSM data found',
    message: 'Error: Could not create or update Stripe subscription',
  },
  {
    error: 'No subscription items found',
    message: 'Error: Could not create or update Stripe subscription',
  },
  {
    error: 'Trial product not found',
    message: 'Error: Could not create or update Stripe subscription',
  },
  {
    error: 'CPP expiration date not provided',
    message: 'Error: Please select an expiration date for the CPP',
  },
  {
    error: 'No subscription found',
    message: 'Error: No subscription found for the site',
  },
  {
    error: 'Unhandled subscription scheduling scenario found for address',
    message: 'Error: Could not create or update Stripe subscription',
  },
];

export const DEFAULT_ERROR = 'Something went wrong. Please try again later.';

export function parseProjectActionError(error: ApolloError): string {
  const errorMessage = error.graphQLErrors.reduce<string | null>((message, graphQLError) => {
    if (message) {
      return message;
    }

    const machineCode = getGraphQLErrorMachineCode(graphQLError);

    switch (machineCode) {
      case MembershipsConfigErrorCode.STRIPE_ACCOUNT_FOR_PARTNER_NOT_FOUND:
      case MembershipsConfigErrorCode.PARTNER_DOES_NOT_HAVE_STRIPE_ACCOUNT:
        return 'Error: No Stripe configuration found for the partner';
      case MembershipsConfigErrorCode.PARTNER_PRICE_POINT_DATA_NOT_FOUND:
        return 'Error: Could not create or update Stripe subscription';
      default:
        return (
          PROJECT_ACTION_ERRORS.find((err) => graphQLError.message.includes(err.error))?.message ??
          null
        );
    }
  }, null);

  return errorMessage || DEFAULT_ERROR;
}
